import React, { useEffect, useState } from 'react';
import { getContent, updateContent } from '../services/contentService';
import Button from '../components/UI/Button';

const AdminContentPage: React.FC = () => {
  const [content, setContent] = useState('');
  const [slug, setSlug] = useState('how-to-create');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getContent(slug).then(data => {
      setContent(data);
      setLoading(false);
    });
  }, [slug]);

  const handleSave = async () => {
    setLoading(true);
    await updateContent(slug, content);
    setLoading(false);
    alert('محتوا با موفقیت ذخیره شد.');
  };

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">مدیریت محتوای آموزشی</h1>
      <select value={slug} onChange={e => setSlug(e.target.value)} className="mb-4 p-2 border rounded">
        <option value="how-to-create">آموزش ایجاد پروژه</option>
        <option value="building-trust">آموزش ایجاد اعتماد</option>
      </select>
      <textarea
        value={content}
        onChange={e => setContent(e.target.value)}
        className="w-full h-96 p-4 border rounded mb-4"
        placeholder="محتوا را به صورت Markdown وارد کنید..."
      />
      <Button onClick={handleSave} disabled={loading}>
        {loading ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
      </Button>
    </div>
  );
};

export default AdminContentPage;
